import { Box, Button, Paper, Typography } from '@mui/material'
import { ERPLoginPageURL } from '../../../shared/utils/constants.jsx'
import { useAuthStore } from '../../store/auth.store'
import notFoundImg from '../../../shared/assets/not-found.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import React from 'react'
import { useUserStore } from '../../store/user.store'

const PageNotFound = () => {

    const AuthStore = useAuthStore()
    const UserStore = useUserStore()
    const navigate = useNavigate()
    const { pathname, search } = useLocation()

    const navigateToSignin = () => {
        if ( pathname?.includes( 'assessment' ) && !pathname?.includes( 'admin' ) )
            return navigate( `/assessment/login`, { replace: true } )
        const redirectValue = encodeURIComponent( `${pathname}${search}` )
        if ( pathname.includes( 'admin' ) )
            navigate( `/admin?redirect=${redirectValue}`, { replace: true } )
        else
            window.location.href = `${ERPLoginPageURL}?redirect=${redirectValue}`
    }

    const handleGoBack = () => {
        if ( window.history.length > 2 )
            return navigate( -1, { replace: true } )
        const role = UserStore.getUser?.user_role?.toLowerCase() || ""
        if ( ['faculty', 'hod', 'principal', 'presenter'].includes( role ) )
            return navigate( `/faculty/home` )
        if ( ['admin', 'subadmin'].includes( role ) )
            return navigate( `/admin/home` )
        if ( role === 'student' )
            return navigate( `/student/home` )
        window.location.href = `${ERPLoginPageURL}`
    }

    return (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1
            }}>
            <Paper sx={{ width: "100%", position: "relative", background: `url('/imgs/bg-pattern1.png')`, padding: "20px 40px", display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", borderRadius: "5px", flexGrow: 1 }}>
                <Box sx={{ borderRadius: "5px", zIndex: 5, background: "rgba(0,0,0,0.7)", position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}></Box>
                {AuthStore.getAuth ? <Box
                    sx={{
                        justifyContent: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        alignItems: "center",
                        zIndex: 10
                    }}>
                    <img width="200px" src={notFoundImg} alt="not-found" />
                    <Typography
                        color="white"
                        variant='subtitle2'
                        sx={{
                            fontSize: "3rem",
                            margin: "0"
                        }}>404</Typography>
                    <Typography
                        color="white"
                        variant='h6'
                        sx={{
                            textAlign: "center",
                            marginTop: "-10px",
                            marginBottom: "20px",
                            fontWeight: "300"
                        }}> <i>The resource you are looking for is unavailable! please check the URL</i> </Typography>
                    <Button disableElevation sx={{ marginBottom: "40px", background: "white", color: "black", textTransform: "capitalize", "&:hover": { background: "white", color: "black", } }} variant='contained' onClick={handleGoBack} >Go Back</Button>
                </Box> :
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10
                        }}>
                        <Typography
                            color="white"
                            variant='subtitle2'
                            sx={{
                                fontSize: "20vh",
                                margin: "0"
                            }}>OOPS!</Typography>
                        <Typography
                            color="white"
                            variant='h6'
                            sx={{
                                textAlign: "center",
                                marginBottom: "20px",
                                fontWeight: "300"
                            }}>
                            <i>Session Ended!</i>
                        </Typography>
                        <Button disableElevation sx={{ background: "white", color: "black", textTransform: "capitalize", "&:hover": { background: "white", color: "black", } }} variant='contained' onClick={navigateToSignin} >Signin</Button>
                    </Box>
                }

            </Paper>
        </Box>
    );
}

export default PageNotFound
